var _$WebSocket_156 = createModuleFactory(function (module, exports) {
"use strict";module.exports=WebSocket;

});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJyb3dzZXIuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsIldlYlNvY2tldCJdLCJtYXBwaW5ncyI6IjtBQUFBLFlBQUEsQ0FFQUEsTUFBQUEsQ0FBT0MsT0FBQUEsQ0FBVUMsU0FBQUEsQ0FBQUEiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==